import {
  BufferGeometry,
  Float32BufferAttribute,
  LineSegments,
  Vector3,
} from 'three';
import { LineBasicNodeMaterial } from 'three/webgpu';

import type { LightningPoint } from './config/types';

// Native, non-instanced segments avoid Drei Line's WebGL LineMaterial and
// three-stdlib LineGeometry's unbounded instanceCount. Dashes are geometry,
// so there is no ShaderMaterial or WebGL onBeforeCompile hook to translate.
export const createLightningGuide = (
  start: LightningPoint,
  end: LightningPoint
) => {
  const origin = new Vector3(...start);
  const direction = new Vector3(...end).sub(origin);
  const length = direction.length();
  const positions: number[] = [];
  if ([...start, ...end, length].every(Number.isFinite) && length > 0) {
    direction.normalize();
    const stride = Math.max(0.04, length / 512);
    for (let distance = 0; distance < length; distance += stride) {
      const a = origin.clone().addScaledVector(direction, distance);
      const b = origin
        .clone()
        .addScaledVector(
          direction,
          Math.min(length, distance + stride * 0.625)
        );
      positions.push(a.x, a.y, a.z, b.x, b.y, b.z);
    }
  }
  const geometry = new BufferGeometry();
  geometry.setAttribute('position', new Float32BufferAttribute(positions, 3));
  geometry.setDrawRange(0, positions.length / 3);
  const material = new LineBasicNodeMaterial({
    color: '#56e5ff',
    depthTest: false,
    depthWrite: false,
  });
  const guide = new LineSegments(geometry, material);
  guide.frustumCulled = false;
  return guide;
};
